import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Link } from "@/components/Interface/Link/Link";
import { Notification } from "@/components/Interface/Notification/Notification";
import { useSimIdFromQueryParam } from "@/hooks/useSimIdFromQueryParam";
import { portalRoutes } from "@/router/routes/portalRoutes";

/**
 * This component displays information about the roaming options.
 * It is displayed if the user has less than three roaming options booked.
 */
export const RoamingGoodToKnow = () => {
  const { t } = useTranslation("portal");
  const navigate = useNavigate();
  const [simId] = useSimIdFromQueryParam();

  return (
    <Notification
      dataTestid="roaming-good-to-know"
      title={t("layout.goodToKnow")}
      description={
        <Trans
          t={t}
          components={[
            <Link
              key={0}
              type="button"
              size="sm"
              onClick={() =>
                navigate(`${portalRoutes.manageDevice.voice}?simId=${simId}`, {
                  replace: true,
                })
              }
            />,
          ]}
          i18nKey="cockpit.managementTile.roaming.showOption.inactive.hint"
        />
      }
    />
  );
};
